import paymentsRoutes from './payments'
import directDebitRoutes from './directDebit'
import directPaymentsRoutes from './directPayments'
import businessDocumentsRoutes from './businessDocuments'
import suppliersRoutes from './suppliers'
import commonRoutes from './commonRoutes'
import verificationRoutes from './verifications'

export default [
  ...paymentsRoutes,
  ...directDebitRoutes,
  ...directPaymentsRoutes,
  ...businessDocumentsRoutes,
  ...suppliersRoutes,
  ...verificationRoutes,
  ...commonRoutes
]
